import { createFileRoute, notFound } from "@tanstack/react-router";
import { getLocation, locationSlugs } from "@/lib/locations";
import { LocationPage } from "@/components/LocationPage";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { graph, serviceSchema, faqPage, breadcrumbList } from "@/lib/schema";

export const Route = createFileRoute("/ar/services/iso-certification/$city")({
  beforeLoad: ({ params }) => {
    if (!locationSlugs.includes(params.city)) throw notFound();
  },
  head: ({ params }) => {
    const l = getLocation(params.city);
    if (!l || !locationSlugs.includes(params.city)) return {};
    const path = `/ar/services/iso-certification/${l.slug}`;
    const url = absolute(path);
    return {
      meta: [
        { title: l.metaTitle.ar },
        { name: "description", content: l.description.ar },
        { property: "og:title", content: l.metaTitle.ar },
        { property: "og:description", content: l.description.ar },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        { property: "og:image", content: OG_IMAGE },
        { property: "og:locale", content: "ar_IQ" },
        { name: "twitter:image", content: OG_IMAGE },
      ],
      links: [
        { rel: "canonical", href: url },
        ...hreflangLinks(`/services/iso-certification/${l.slug}`),
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            graph(
              serviceSchema({
                path,
                name: l.title.ar,
                serviceType: l.serviceType?.ar ?? `ISO certification in ${l.city.en}`,
                description: l.description.ar,
                areaServed: l.areaServed,
              }),
              faqPage(
                path,
                l.faq.map((f) => ({ q: f.q.ar, a: f.a.ar })),
              ),
              breadcrumbList([
                { name: "الرئيسية", path: "/ar" },
                { name: "خدماتنا", path: "/ar/services" },
                { name: l.title.ar, path },
              ]),
            ),
          ),
        },
      ],
    };
  },
  component: LocationRoutePageAr,
});

function LocationRoutePageAr() {
  const { city } = Route.useParams();
  const l = getLocation(city);
  if (!l || !locationSlugs.includes(city)) throw notFound();
  return <LocationPage location={l} />;
}
